import React from "react";
import useFormValidation from "./useFormValidation";
import validateLogin from "./validateLogin";
import firebase from '../../firebase';
import { Container, Avatar, Typography, TextField, Button, Grid, Link, Divider } from '@material-ui/core';
import LockOutlineIcon from "@material-ui/icons/LockOutlined";
import { withRouter } from 'react-router-dom';

const style = {
  paper: {
    marginTop: 9,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: 5,
    backgroundColor: "red"
  },
  form: {
    width: "100%",
    marginTop: 8
  },
  submit: {
    marginTop: 10,
    marginBottom: 20
  }

}

const INITIAL_STATE = {
  name: "",
  email: "",
  password: ""
};

function AdminLogin(props) {
  const {
    handleSubmit,
    handleBlur,
    handleChange,
    values,
    errors,
    isSubmitting
  } = useFormValidation(INITIAL_STATE, validateLogin, authenticateUser);
  const [login, setLogin] = React.useState(true);
  const [firebaseError, setFirebaseError] = React.useState(null)

  async function authenticateUser() {
    const { name, email, password } = values;
    try {
      login
        ? await firebase.login(email, password)
        : await firebase.register(name, email, password);
      props.history.push("/ciclos");
    } catch (err) {
      console.error('Authentication Error', err)
      setFirebaseError(err.message)
    }
  }

  return (
    <div>
      <Container maxWidth="xs">
        <div style={style.paper}>
          <Avatar style={style.avatar}>
            <LockOutlineIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Ingrese Usuario
          </Typography>
          <form style={style.form} onSubmit={handleSubmit}>
            {!login && (
              <TextField
                variant="outlined"
                label="Nombre"
                name="name"
                fullWidth
                margin="normal"
                placeholder="Tu nombre"
                autoComplete="off"
                onChange={handleChange}
                value={values.name}
              />
            )}
            <TextField
              variant="outlined"
              label="E-Mail"
              name="email"
              type="email"
              className={errors.email && 'error-input'}
              placeholder="Tu email"
              fullWidth
              margin="normal"
              onChange={handleChange}
              value={values.email}
            />
            {errors.email && <p className="error-text">{errors.email}</p>}

            <TextField
              variant="outlined"
              label="Password"
              type="password"
              name="password"
              type="password"
              className={errors.password && 'error-input'}
              placeholder="Ingresa tu password"
              fullWidth
              margin="normal"
              onChange={handleChange}
              value={values.password}
            />
            {errors.password && <p className="error-text">{errors.password}</p>}
            {firebaseError && <p className="error-text">{firebaseError}</p>}
              <Button
                type="submit"
                fullWidth
                disabled= {isSubmitting}
                variant="contained"
                color="primary"
               style={style.submit}
              >
              {login ? "Ingresar" : "Registrar"}
            </Button>
            <Divider/>
            <Divider/>
            <Button
                type="button"
                fullWidth
                disabled= {isSubmitting}
                variant="contained"
                color="secondary"
                onClick={() => setLogin(prevLogin => !prevLogin)}
               stylei={style.submit}
              >
               {login ? "Aun no tienes cuenta?" : "ya tiene cuenta?"}
            </Button>
          </form>

          <div className="forgot-password" >
          <Link href="/forgot">Olvidaste tu password?</Link>
          </div>
        </div>
      </Container>    
    </div>
  );
}

export default withRouter(AdminLogin);
